export const cutStringByRegExp = (text: string, condition: RegExp): string =>
    text ? text.replace(condition, '') : ''
